import "./messages-list.scss";

import { customElement, bindable, bindingMode, autoinject } from "aurelia-framework";
import { Router } from "aurelia-router";

import { IConversationNavOptions } from "../../../interfaces/i-message";
import Infrastructure from "../../../common/infrastructure";

@autoinject
@customElement("messages-list")
export class MessagesList {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public isAxxessChat: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public conversations: IConversationNavOptions[] = [];
    private _router: Router;
    public axxessChatUrl: string = `${Infrastructure.axxessCentral}/central-messaging/clinicians/conversation`;

    public constructor(router: Router) {
        this._router = router;
    }

    public handleMenuSelection(conversation: IConversationNavOptions) {
        if (this.isAxxessChat) {
            this._router.navigate(`${this.axxessChatUrl}/${conversation.id}`);
            return;
        }
        this._router.navigate(`/message-center/conversation/${conversation.id}`);
    }
}
